import http from "@/settings/apiSettings"

class EmploymentTypesDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/PER_EmploymentTypes", data)
    }
}
export default new EmploymentTypesDataService()